import { useMemo } from "react";
import { SelectInput } from "../../../components/SelectInput/SelectInput";
import dayjs from "dayjs";
import { secondsToHours } from "../../../services/utils";
import { Skeleton } from "../../../components/Skeleton";
import { ReactComponent as StarIcon } from "../../../assets/icons/star.svg";



export function Summary({
    selectedMonth,
    selectedYear,
    setSelectedMonth,
    setSelectedYear,
    summaryData,
    isLoading,
}: {
    selectedMonth: string;
    selectedYear: string;
    setSelectedMonth: (month: string) => void;
    setSelectedYear: (year: string) => void;
    summaryData: any;
    isLoading: boolean;
}) {
    const handleSelectMonth = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedMonth(e.target.value);
    }
    const handleSelectYear = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newYear = e.target.value;
        setSelectedYear(newYear);
        const maxMonth = Number(newYear) === dayjs().year() ? dayjs().month() + 1 : 12;
        if (Number(selectedMonth) > maxMonth) {
            setSelectedMonth(String(maxMonth));
        }
    }
    const years = useMemo(() => {
        const startYear = 2024;
        const currentYear = dayjs().year();
        return Array.from({ length: currentYear - startYear + 1 }, (_, index) => ({ label: `${startYear + index}`, value: `${startYear + index}` }));
    }, []);
    const months = useMemo(() => {
        const count = Number(selectedYear) === dayjs().year() ? dayjs().month() + 1 : 12;
        return Array.from({ length: count }, (_, index) => ({
            label: dayjs().month(index).format("MMMM"),
            value: `${index + 1}`,
        }));
    }, [selectedYear]);



    return (
        <div data-testid="call-history-summary" className="w-full">
            <div className="flex justify-between items-center w-full">
                <div className="uppercase flex gap-1 items-center text-[clamp(12px,1.5vw,14px)] font-semibold text-text-primary">
                    <span>{dayjs().month(Number(selectedMonth) - 1).format("MMMM")}</span>
                    <span>{selectedYear}</span>
                    <span>Summary</span>
                </div>
                <div className="flex gap-2 items-center">
                    <SelectInput
                        containerClassName="w-[110px]"
                        options={months}
                        placeholder="Select Month"
                        className="w-full text-[clamp(12px,1.5vw,14px)] px-3 font-semibold h-full min-h-[27px] w-[110px] rounded-full outline-none !border-none bg-gray-100"
                        value={selectedMonth}
                        onChange={handleSelectMonth}
                    />
                    <SelectInput
                        containerClassName="w-24"
                        options={years}
                        placeholder="Select Year"
                        className="w-full text-[clamp(12px,1.5vw,14px)] px-3 font-semibold h-full min-h-[27px] w-24 rounded-full outline-none !border-none bg-gray-100"
                        value={selectedYear}
                        onChange={handleSelectYear}
                    />
                </div>
            </div>
            <div className="flex gap-3 items-center mt-4">
                <div className="bg-secondary2 rounded-md py-[5px] w-[140px] flex flex-col justify-center items-center gap-1">
                    {isLoading ? <Skeleton className="w-8 h-5 my-1" /> : <span className="text-[clamp(16px,1.5vw,18px)] font-semibold text-text-primary">{summaryData?.totalSessions}</span>}
                    <span className="uppercase text-[clamp(10px,1.5vw,12px)] font-semibold text-text-primary">Sessions</span>
                </div>
                <div className="bg-secondary2 rounded-md py-[5px] w-[140px] flex flex-col justify-center items-center gap-1">
                    {isLoading ? <Skeleton className="w-8 h-5 my-1" /> : <span className="flex items-center gap-1.5 text-[clamp(16px,1.5vw,18px)] font-semibold text-text-primary"><StarIcon className="w-[19px] h-[17px] [&_path]:fill-[#FFBA53]" />{summaryData?.avgScore}</span>}
                    <span className="uppercase text-[clamp(10px,1.5vw,12px)] font-semibold text-text-primary">AVG Score</span>
                </div>
                <div className="bg-secondary2 rounded-md py-[5px] w-[140px] flex flex-col justify-center items-center gap-1">
                    {isLoading ? <Skeleton className="w-12 h-5 my-1" /> : <span className="text-[clamp(16px,1.5vw,18px)] font-semibold text-text-primary">{secondsToHours(Number(summaryData?.avgDuration || 0))}</span>}
                    <span className="uppercase text-[clamp(10px,1.5vw,12px)] font-semibold text-text-primary">AVG Call time</span>
                </div>
                
            </div>
        </div>
    );
}